import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Button, Card, CardHeader, Divider, LinearProgress, Typography } from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/core/styles';

import { S3VideoObjectInput } from 'api';
import { Video as VideoPlayer } from 'components';
import { useProgress } from 'hooks';

import { RemoveTypes } from '../../types';
import styles from './styles';

interface IProps extends WithStyles<typeof styles> {
  video: S3VideoObjectInput;
  working: boolean;
  onRemove: (type: RemoveTypes) => () => void;
}

const Video: FC<IProps> = ({ classes, onRemove, working, video }) => {
  const { t } = useTranslation();
  const value = useProgress();

  const isUploading = working && onRemove;
  const showRemove = !working && onRemove;
  const uploadKey = working && value === 100 ? 'common:saving' : 'posting:uploadInProgress';

  return (
    <div className={classNames(classes.placeholder, classes.photoSpacer)}>
      <Card elevation={0} className={classes.card} square>
        <Divider />
        <LinearProgress variant="determinate" value={value} />
        <CardHeader
          disableTypography
          classes={{ root: classes.cardHeaderRoot, content: classes.cardHeaderContent }}
          subheader={isUploading && <Typography variant="body2">{t(uploadKey)}</Typography>}
          action={
            showRemove && (
              <Button className={classes.button} onClick={onRemove(RemoveTypes.Video)}>
                {t('posting:removeVideo')}
              </Button>
            )
          }
        />
        <div className={classes.photo}>
          <VideoPlayer video={video} />
        </div>
      </Card>
    </div>
  );
};

export default withStyles(styles)(Video);
